import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["actions", "children", "open", "openAtColumnIndex", "TH", "TR"];
import { Children } from 'react';
import styled from 'foundations-theming/utils';
import { useMapTokenPropsToCSS } from '../../../hooks/useMapTokenPropsToCSS';
import { filterProps } from '../../../utils/filterProps';
import { CSS_SPECIFICITY } from '../../constants/CSSSpecificity';
import { jsx as _jsx } from "react/jsx-runtime";
const ActionsRowTR = styled.tr.withConfig({
  displayName: "TableActionsRow__ActionsRowTR",
  componentId: "vwmvr5-0"
})(({
  $cssStyles
}) => {
  return Object.assign({
    position: 'relative'
  }, $cssStyles);
});
const ActionsRowTH = styled.th.withConfig({
  displayName: "TableActionsRow__ActionsRowTH",
  componentId: "vwmvr5-1"
})(({
  theme
}) => {
  return {
    [CSS_SPECIFICITY.OVERRIDE]: {
      fontSize: theme.typography['body-100'].fontSize,
      fontWeight: theme.typography['body-300'].fontWeight,
      paddingInlineEnd: theme.space['0'],
      textTransform: 'none'
    }
  };
});
const StyledLabel = styled.div.withConfig({
  displayName: "TableActionsRow__StyledLabel",
  componentId: "vwmvr5-2"
})(({
  theme
}) => {
  return {
    color: theme.color['text-core-subtle']
  };
});
function renderWithActions(TH, actions, children, openAtColumnIndex) {
  const childArray = Children.toArray(children);
  const visibleChildren = childArray.slice(0, openAtColumnIndex);
  return visibleChildren.concat([/*#__PURE__*/_jsx(TH, {
    colSpan: childArray.length - openAtColumnIndex,
    children: /*#__PURE__*/_jsx(StyledLabel, {
      children: actions
    })
  }, "actions")]);
}

// we're only extending SizeStyleProps here for now because this is a table-row
// so the vast majority of things like padding, margin, etc. are not applicable
export const TableActionsRow = _ref => {
  let {
      actions,
      children,
      open = false,
      openAtColumnIndex,
      TH = ActionsRowTH,
      TR = ActionsRowTR
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  const {
    domProps,
    tokenProps,
    callbackProps,
    restProps
  } = filterProps(rest);
  const cssStyles = useMapTokenPropsToCSS(tokenProps);
  return /*#__PURE__*/_jsx(TR, Object.assign({}, domProps, callbackProps, restProps, {
    role: "presentation",
    "aria-live": "polite",
    $cssStyles: cssStyles,
    children: open ? renderWithActions(TH, actions, children, openAtColumnIndex) : children
  }));
};